var map = {
	"./1.jpg": "ae36",
	"./2.jpg": "5c47",
	"./3.jpg": "64ad",
	"./4.jpg": "acfb",
	"./5.jpg": "f7f1",
	"./6.jpg": "2e7f",
	"./7.jpg": "2208"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2d42";